var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-small-component-static",style:('background-image:url('+_vm.getImage()+')')},[_c('div',{staticClass:"map-overlay",on:{"click":_vm.openMap}})])}
var staticRenderFns = []

export { render, staticRenderFns }